import { createNativeStackNavigator } from "@react-navigation/native-stack";
import DevHomeScreen from "./DevHomeScreen";
import DevComingSoonScreen from "./DevComingSoonScreen";
import DevComingSoonInventoryScreen from "./DevComingSoonInventoryScreen";
import DevCoverageCardFixtureScreen from "./DevCoverageCardFixtureScreen";
import DevFieldPlaygroundScreen from "./DevFieldPlaygroundScreen";
import DevFilterChipAuditScreen from "./DevFilterChipAuditScreen";
import DevButtonAuditScreen from "./DevButtonAuditScreen";
import DevPharmacyQuoteClaimsScreen from "./DevPharmacyQuoteClaimsScreen";

export type DevFilterChipAuditVariant =
  | "pharmacy"
  | "therapies-filter-comparison"
  | "document-option-chip-grid"
  | "beta-result-chip-button"
  | "legacy-clinics-filter-chip";

export type DevButtonAuditVariant =
  | "matrix"
  | "current-routes"
  | "section-actions"
  | "icon-buttons"
  | "compact-actions"
  | "floating-actions"
  | "package-level";

export type DevStackParamList = {
  DevHome: undefined;
  DevComingSoon: undefined;
  DevComingSoonInventory: undefined;
  DevCoverageCardFixture: undefined;
  DevFieldPlayground: undefined;
  DevFilterChipAudit: { variant?: DevFilterChipAuditVariant } | undefined;
  DevButtonAudit: { variant?: DevButtonAuditVariant } | undefined;
  DevPharmacyQuoteClaims: undefined;
};

const Stack = createNativeStackNavigator<DevStackParamList>();

export default function DevNavigator() {
  return (
    <Stack.Navigator screenOptions={{ headerShown: false }}>
      <Stack.Screen name="DevHome" component={DevHomeScreen} />
      <Stack.Screen name="DevComingSoon" component={DevComingSoonScreen} />
      <Stack.Screen
        name="DevComingSoonInventory"
        component={DevComingSoonInventoryScreen}
      />
      <Stack.Screen
        name="DevCoverageCardFixture"
        component={DevCoverageCardFixtureScreen}
      />
      <Stack.Screen
        name="DevFieldPlayground"
        component={DevFieldPlaygroundScreen}
      />
      <Stack.Screen
        name="DevFilterChipAudit"
        component={DevFilterChipAuditScreen}
      />
      <Stack.Screen name="DevButtonAudit" component={DevButtonAuditScreen} />
      <Stack.Screen
        name="DevPharmacyQuoteClaims"
        component={DevPharmacyQuoteClaimsScreen}
      />
    </Stack.Navigator>
  );
}
